import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import {
	AVAILABILITY_STATUS_ALL,
	AVAILABILITY_STATUS_IDLE,
	AVAILABILITY_STATUS_ON_ABSENCE,
	AVAILABILITY_STATUS_ON_ASSIGNMENT,
	AVAILABILITY_STATUS_ON_PROTECTION,
	AVAILABILITY_STATUS_RESTING,
	AVAILABILITY_STATUS_VALUE_IDLE,
	AVAILABILITY_STATUS_VALUE_ON_ABSENCE,
	AVAILABILITY_STATUS_VALUE_ON_ASSIGNMENT,
	AVAILABILITY_STATUS_VALUE_ON_PROTECTION,
	AVAILABILITY_STATUS_VALUE_RESTING,
} from 'pages/CrewTimeline/components/TimeLineFilter/const';

const STATUS_FILTER_OPTIONS = [
	{ value: '', label: AVAILABILITY_STATUS_ALL },
	{ value: AVAILABILITY_STATUS_VALUE_IDLE, label: AVAILABILITY_STATUS_IDLE },
	{
		value: AVAILABILITY_STATUS_VALUE_ON_ASSIGNMENT,
		label: AVAILABILITY_STATUS_ON_ASSIGNMENT,
	},
	{ value: AVAILABILITY_STATUS_VALUE_ON_ABSENCE, label: AVAILABILITY_STATUS_ON_ABSENCE },
	{
		value: AVAILABILITY_STATUS_VALUE_ON_PROTECTION,
		label: AVAILABILITY_STATUS_ON_PROTECTION,
	},
	{ value: AVAILABILITY_STATUS_VALUE_RESTING, label: AVAILABILITY_STATUS_RESTING },
	// TODO: CHECK
	// { value: AVAILABILITY_STATUS_VALUE_UNKNOWN, label: AVAILABILITY_STATUS_UNKNOWN },
];

const AvailabilityStatusFilter = ({ fieldControl, submitOnChange }) => {
	const renderOptions = (options) => {
		return options.map((option) => (
			<SelectOption key={option.value} value={option.value}>
				{option.label}
			</SelectOption>
		));
	};

	const handleOnSelect = (e) => {
		fieldControl.onChange(e.target.value);
		submitOnChange();
	};

	return (
		<Select
			id="availability-status-filter"
			label="Driver status"
			value={fieldControl.value || ''}
			onChange={(e) => handleOnSelect(e)}
		>
			{renderOptions(STATUS_FILTER_OPTIONS)}
		</Select>
	);
};

export default AvailabilityStatusFilter;
